import React, { useState, useEffect } from 'react';
import './EditableCommentField.scss';
import editIcon from 'assets/images/icons/users/edit.svg';

export type EditableCommentFieldProps = {
    label: string;
    value: string | null | undefined;
    placeholder?: string;
    onSave: (newValue: string) => Promise<void>;
    rows?: number;
};

export const EditableCommentField: React.FC<EditableCommentFieldProps> = ({
    label,
    value,
    placeholder,
    onSave,
    rows = 4
}) => {
    const [isEditing, setIsEditing] = useState(false);
    const [draft, setDraft] = useState(value ?? '');
    const [isSaving, setIsSaving] = useState(false);

    useEffect(() => {
        setDraft(value ?? '');
    }, [value]);

    const handleEdit = () => setIsEditing(true);

    const handleCancel = () => {
        setDraft(value ?? '');
        setIsEditing(false);
    };

    const handleSave = async () => {
        setIsSaving(true);
        try {
            await onSave(draft);
            setIsEditing(false);
        } finally {
            setIsSaving(false);
        }
    };

    return (
        <div className="editable-comment-field">
            <label className="editable-comment-field__label">{label}</label>
            <textarea
                className="editable-comment-field__textarea"
                value={draft}
                onChange={(e) => setDraft(e.target.value)}
                placeholder={placeholder ?? ''}
                rows={rows}
                disabled={!isEditing || isSaving}
                aria-label={label}
            />
            <div className="editable-comment-field__actions">
                {!isEditing ? (
                    <button
                        type="button"
                        className="editable-comment-field__btn editable-comment-field__btn--edit"
                        onClick={handleEdit}
                    >
                        <img src={editIcon} alt="" aria-hidden="true" />
                        <span>Modifier mon commentaire</span>
                    </button>
                ) : (
                    <>
                        <button
                            type="button"
                            className="editable-comment-field__btn editable-comment-field__btn--cancel"
                            onClick={handleCancel}
                            disabled={isSaving}
                        >
                            Annuler
                        </button>
                        <button
                            type="button"
                            className="editable-comment-field__btn editable-comment-field__btn--save"
                            onClick={handleSave}
                            disabled={isSaving}
                        >
                            {isSaving ? 'Enregistrement…' : 'Enregistrer'}
                        </button>
                    </>
                )}
            </div>
        </div>
    );
};
